<template>
  <Restrictions v-model="settings" />
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  computed: {
    ...mapGetters(['member']),
    settings: {
      get() {
        return {...this.member.settings||{}, current_producttemplate: this.member.current_producttemplate}
      },
      async set({current_producttemplate, ...settings}={}) {
        let {id} = this.member;
        await this.updateUserProfile({id, current_producttemplate, settings});
      }
    }
  },
  methods: {
    ...mapActions(['updateUserProfile'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/MemberRestrictions.vue